export function validatePass(password) {
  const err = {};
  err.valid = true;

  var passwordRules = 'minimum of eight characters, with at least one number';

  if(password.length < 8) {
    err.message = passwordRules;
    err.valid = false;
  }
  var re = /[0-9]/;
  if(!re.test(password)) {
    err.message = passwordRules;
    err.valid = false;
  }

  return err;
}
